import { GameController, Device, GameGenre, GameStatus, PEGIRating } from './Game';

export enum SessionDuration {
  LESS_10 = '< 10 mn',
  BETWEEN_10_30 = '10 - 30 mn',
  MORE_30 = '> 30 mn',
}
export default interface SearchFormData {
  controllers?: GameController[];
  devices?: Device[];
  genres?: GameGenre[];
  languages?: string[];
  multiplayer?: boolean;
  solo?: boolean;
  name?: string;
  sessionDurations?: SessionDuration[];
  statuses?: GameStatus[];
  age?: PEGIRating[];
}
